import { useState } from 'react';
import { Carousel, Col, Container, Image, Row } from 'react-bootstrap';
import { PageMeta } from '../../../components/meta/PageMeta';
import { StickySubNav } from '../../../components/nav/StickySubNav';
import { BannerHeader } from '../../user/BannerHeader';
import { useGetGalleryQuery } from '../../../services/endpoints/website/gallery';
import { getPartition } from '../../../utils/utils';
import Dots from '../../../assets/images/sfc-dots.png';
import img006 from '../../../assets/images/privateEvents/sticky-fingers-cooking-birthday-parties-for-kids_006.jpg';
import img002 from '../../../assets/images/privateEvents/sticky-fingers-cooking_birthday-parties_02.jpg';
import img003 from '../../../assets/images/privateEvents/sticky-fingers-cooking-birthday-parties-for-kids_003.jpg';
import img03 from '../../../assets/images/privateEvents/sticky-fingers-cooking_birthday-parties_03.jpg';
import img04 from '../../../assets/images/privateEvents/sticky-fingers-cooking_birthday-parties_04.jpg';
import './PrivateEvents.css';


const NAV_ITEMS = [
  { label: 'In-Person Birthday Parties', id: 'in-person-birthday-parties' },
  { label: 'Birthday Party Video', id: 'birthday-party-video' },
  { label: 'Online Birthday Parties', id: 'online-birthday-parties' },
  { label: 'Testimonials', id: 'birthday-party-testimonials' },
  { label: 'Gallery', id: 'birthday-party-gallery' },
];

const TESTIMONIALS = [
  { quote: "Thank you for the awesome cooking birthday party for my daughter and her friends yesterday!", author: "Paul H., Colorado" },
  { quote: "The kids were engaged the entire time. It was one of the best birthdays we have ever hosted.", author: "Michelle G., Texas" },
  { quote: "The party was terrific; we received many happy texts from parents saying how much they enjoyed it.", author: "Ben, Colorado" },
  { quote: "I think the online party was as much fun, if not more, than having it in person. Thanks!", author: "P. Henry, Colorado" },
  { quote: "Recipes were fun and delicious. All the kids had so much fun. Definitely a memorable birthday.", author: "Michelle S., Illinois" },
  { quote: "The party was great. Madison really enjoyed herself! The whole experience was excellent.", author: "Jennifer S., New York" },
];

const BirthdayParties: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { data: galleryData } = useGetGalleryQuery(3);
  return (
      <>
        <PageMeta
            title="Cooking Birthday Parties for Kids - Sticky Fingers Cooking"
            description="Make your child's next birthday awesomely unique with a Sticky Fingers Cooking birthday party! Fun cooking parties for kids ages 5-14."
        />
        <BannerHeader title="In-Person & Online Birthday Parties" />
        <StickySubNav items={NAV_ITEMS} />

        <div id="in-person-birthday-parties" className="section-events-child">
          <Container>
            <div className="container-flex">
              <div className="div-block-events-large">
                <h2>Truly Tasty In-Person Birthday Parties</h2>
                <Image className="w-100 dots-divider my-2" src={Dots} />
                <p>Make your child's next birthday party truly tasty with a Sticky Fingers Cooking® birthday party! We offer fun at-home birthday parties for kids ages 5–14. Our parties are filled with COOL'inary adventure and delicious fun! Each party includes a theme, a craft, and a themed game, plus optional food challenges for older kids. Choose your theme, and we'll create a memorable, delicious celebration your child will never forget!</p>
                <ul className="w-list-unstyled">
                  <li>Oodles of Asian Noodles Party!</li>
                  <li>Mix it Up Mac and Cheese Pasta Party!</li>
                  <li>Creative Calzone Celebration!</li>
                  <li>The Pie's the Limit Party!</li>
                  <li>Perfect Pancake Party!</li>
                </ul>
                <p><strong>Let us take care of the details of your in-person birthday party!</strong> Parents provide the food items to be cooked in the recipes, as well as the birthday cake/cupcakes. Sticky Fingers provides the following:</p>
                <ul className="w-list-unstyled">
                  <li>An amazing Sticky Fingers chef instructor</li>
                  <li>A food shopping list specific to your theme</li>
                  <li>A personalized Sticky Fingers Cooking chef apron embroidered with your child's name</li>
                  <li>Colorful recipe cards for all guests personalized with your child's name</li>
                  <li>Kid-sized chef hats for all guests to decorate</li>
                  <li>Craft and themed activity supplies</li>
                  <li>All the kid-sized cooking equipment needed</li>
                  <li>Set-up and clean-up</li>
                  <li>Accommodation for ANY and ALL allergies and dietary restrictions</li>
                  <li>A memorable birthday party that's a blast for all ages!</li>
                </ul>
                <p><strong>Prices vary by location.</strong> Send us your details, and we'll whip you up a quote!</p>
                <a href="/contact" className="btn-events">Book Your Party</a>
              </div>
              <div className="div-block-events-small">
                <div className="div-image">
                  <img src={img006} alt="Group of girls enjoying a Sticky Fingers birthday party" className="image-events" />
                </div>
                <div className="div-image">
                  <img src={img002} alt="Two girls cooking at a Sticky Fingers birthday party" className="image-events rotate-left" />
                </div>
              </div>
            </div>
          </Container>
        </div>

        <div id="birthday-party-video" className="section-video">
          <Container>
            <Row className="align-items-center">
              <Col lg={4} className="mb-4 mb-lg-0">
                <div className="subheader white">memorable online birthday parties</div>
                <h2>Sticky Fingers Cooking Brings the Fun</h2>
                <p>At Sticky Fingers Cooking, we're making online birthdays fabulous and delicious. Celebrate in a new way that will satisfy your COOL'inary curiosity. Our one-of-a-kind online birthday parties bring family and friends together through cooking.</p>
                <a href="/contact" className="btn-events">Book Today</a>
              </Col>
              <Col lg={8}>
                <div className="video-wrapper">
                  <iframe src="https://player.vimeo.com/video/502801986?loop=1" allow="autoplay; fullscreen" allowFullScreen title="Birthday Party Video" />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div id="online-birthday-parties" className="section-events-child alt">
          <Container>
            <div className="container-flex">
              <div className="div-block-events-large">
                <h2>Deliciously Delightful Online Birthday Parties</h2>
                <Image className="w-100 dots-divider my-2" src={Dots} />
                <p>Make your child's next birthday awesomely unique with a Sticky Fingers Cooking <strong>online</strong> birthday party! Our online parties are a safe alternative to traditional parties and allow friends and family to join in the cooking fun <strong>from anywhere!</strong> For ages 5-14, our 90 minute long parties are packed full of amazing COOL'inary adventures and delicious fun!</p>
                <h3>Popular Online Party Recipes</h3>
                <p>Choose your recipe and we’ll whip up a truly memorable and delicious party for your child!</p>
                <ul className="w-list-unstyled">
                  <li>Strawberry Banana Birthday Pudding Cake</li>
                  <li>Coco Loco Berry Buckle Birthday Cake</li>
                  <li>Superbly Tasty Birthday Thai Noodle Salad + Perky Pineapple Coolers</li>
                  <li>Great Grecian Birthday Personal Pizza (for older chefs)</li>
                </ul>
                <p><strong>Let us take care of the details of your online birthday party!</strong> Parents provide the food items to be cooked in the recipes. Sticky Fingers provides the following:</p>
                <ul className="w-list-unstyled">
                  <li>One of our amazing Sticky Fingers chef instructors</li>
                  <li>A personalized Sticky Fingers Cooking chef apron embroidered with your birthday child's name</li>
                  <li>Your choice of delicious birthday recipe</li>
                  <li>A personalized invite that can be emailed to party guests</li>
                  <li>A printable shopping list and craft</li>
                  <li>A private video link for just your party</li>
                  <li>A fun, interactive game to play with the whole group</li>
                  <li>Accommodation for ANY and ALL allergies and dietary restrictions</li>
                  <li>An optional goodie bag add-on (including chef hats, kid-safe Sticky Fingers knives, and other fun goodies)</li>
                </ul>
                <a href="/contact" className="btn-events">Book Your Party</a>
              </div>
              <div className="div-block-events-small">
                <div className="div-image">
                  <img src={img03} alt="Kid giving peace sign at a Sticky Fingers online birthday party" className="image-events" />
                </div>
                <div className="div-image">
                  <img src={img04} alt="Kid cooking at a Sticky Fingers online birthday party" className="image-events rotate-left" />
                </div>
              </div>
            </div>
          </Container>
        </div>

        <section id="birthday-party-testimonials" className="section-testimonial-slider">
          <Container>
            <Row>
              <Col lg={7}>
                <Carousel controls={false} indicators={false} interval={4500} activeIndex={activeIndex} onSelect={(i) => setActiveIndex(i)}>
                  {TESTIMONIALS.map((t, i) => (
                      <Carousel.Item key={i}>
                        <div className="text-quote">"{t.quote}"</div>
                        <div className="subheader white">{t.author}</div>
                      </Carousel.Item>
                  ))}
                </Carousel>
              </Col>
            </Row>
            <Row>
              <Col lg={7}>
                <div className="testimonial-dots">
                  {TESTIMONIALS.map((_, i) => (
                      <button key={i} className={`testimonial-dot${activeIndex === i ? ' active' : ''}`} onClick={() => setActiveIndex(i)} />
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Gallery */}
        {galleryData?.gallery?.pictures && galleryData.gallery.pictures.length > 0 && (
            <div id="birthday-party-gallery" className="section-events-child">
              <Container>
                <div className="photo-grid">
                  {galleryData.gallery.pictures.map((pic, i) => (
                      <div key={i} className="photo-grid-item">
                        <img
                            src={`${pic.s3_base_url}/${getPartition(pic.id)}/original/${pic.image_file_name}`}
                            alt={pic.name ?? `Sticky Fingers birthday party ${i + 1}`}
                        />
                      </div>
                  ))}
                </div>
              </Container>
            </div>
        )}
      </>
  );
};

export default BirthdayParties;